// extracted by mini-css-extract-plugin
export var avatar = "_qj-3";
export var avatarContainer = "_qj-2";
export var avatarSpacer = "_qj-5";
export var avatarSpacerContainer = "_qj-4";
export var avatarStackContainer = "_qj-1";
export var bubble = "_qj-0";
export var remainderBubble = "_qj-6";